<template>
  <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.5 10C3.5 5.02944 7.52944 1 12.5 1C17.4706 1 21.5 5.02944 21.5 10C21.5 12.5262 20.3532 14.7402 18.7923 16.767C17.488 18.4606 15.8183 20.1158 14.1506 21.769L14.1495 21.7702C13.8345 22.0825 13.5195 22.3947 13.2071 22.7071C12.8166 23.0976 12.1834 23.0976 11.7929 22.7071C11.4803 22.3945 11.1644 22.0813 10.8492 21.7688C9.18146 20.1156 7.51205 18.4606 6.20772 16.767C4.64683 14.7402 3.5 12.5262 3.5 10ZM15.5 10C15.5 11.6569 14.1569 13 12.5 13C10.8431 13 9.5 11.6569 9.5 10C9.5 8.34315 10.8431 7 12.5 7C14.1569 7 15.5 8.34315 15.5 10Z"
      fill="#0D2948"
    />
  </svg>
</template>
